import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { CategoryItem } from '@/services/reparoly/categoriesApi';

export type CategoriesState = {
  items: CategoryItem[];
  loaded: boolean;
};

const initialState: CategoriesState = {
  items: [],
  loaded: false,
};

// Se normaliza cualquier shape recibido desde RTK Query o formularios para mantener consistencia local.
export function normalizeCategory(input: any): CategoryItem {
  return {
    id: Number(input?.id ?? input?.ID ?? 0),
    name: String(input?.name ?? input?.Name ?? ''),
  };
}

// Se inserta o actualiza una categoría según exista en la colección actual.
function upsert(list: CategoryItem[], record: CategoryItem): CategoryItem[] {
  const idx = list.findIndex((item) => item.id === record.id);
  if (idx >= 0) {
    const next = list.slice();
    next[idx] = { ...next[idx], ...record };
    return next;
  }
  return [record, ...list];
}

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategories(state, action: PayloadAction<{ items: any[] }>) {
      const incoming = (action.payload?.items ?? []).map(normalizeCategory);
      const map = new Map<number, CategoryItem>();
      for (const item of state.items) map.set(item.id, item);
      for (const item of incoming) map.set(item.id, { ...(map.get(item.id) || ({} as CategoryItem)), ...item });
      state.items = Array.from(map.values());
      state.loaded = true;
    },
    upsertCategory(state, action: PayloadAction<any>) {
      const record = normalizeCategory(action.payload);
      state.items = upsert(state.items, record);
      state.loaded = true;
    },
    clearCategories(state) {
      state.items = [];
      state.loaded = false;
    },
  },
});

export const { setCategories, upsertCategory, clearCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;
